module.exports = __webpack_public_path__ + "static/media/commerce3.62b90991.webp";